import { render } from "./PageBuilder.vue?vue&type=template&id=077ae7d4"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"

import "./PageBuilder.vue?vue&type=style&index=0&id=077ae7d4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__